import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CC from "vanilla-cookieconsent";

let booted = false;

export function bootCookieConsent() {
  if (booted) return;
  booted = true;

  void CC.run({
    guiOptions: {
      consentModal: { layout: "box", position: "bottom right", flipButtons: false },
      preferencesModal: { layout: "box", position: "right" },
    },
    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
    },
    language: {
      default: "nb",
      translations: {
        nb: {
          consentModal: {
            title: "Vi bruker informasjonskapsler",
            description:
              "Vi bruker kun nødvendige informasjonskapsler og lokal lagring for at handlekurven og samtykke-valget ditt skal fungere. Ingen analyse- eller markedsførings-cookies. Du kan se detaljer eller endre valget når som helst.",
            acceptAllBtn: "OK",
            showPreferencesBtn: "Detaljer",
            footer:
              '<a href="/personvern">Personvernerklæring</a> · <a href="/vilkar-fastgiver">Vilkår</a>',
          },
          preferencesModal: {
            title: "Administrer informasjonskapsler",
            acceptAllBtn: "OK",
            savePreferencesBtn: "Lagre valg",
            closeIconLabel: "Lukk",
            sections: [
              {
                title: "Informasjonskapsler vi bruker",
                description:
                  'Håp Naturlab bruker i dag kun strengt nødvendige informasjonskapsler. Besøksstatistikk samles inn anonymt og uten cookies via Vercel Analytics. Betaling skjer hos Vipps og Kustom på deres egne domener, så vi lagrer ingen tredjeparts-cookies på denne siden. Se <a href="/personvern" class="cc__link">personvernerklæringen</a> for detaljer.',
              },
              {
                title: "Strengt nødvendige",
                description:
                  "Lagrer handlekurven din lokalt i nettleseren og husker hvilket valg du gjorde i denne dialogen. Kan ikke slås av – uten dette fungerer ikke butikken og fastgiver-skjemaet.",
                linkedCategory: "necessary",
              },
            ],
          },
        },
      },
    },
  });
}

/** Open the preferences modal from anywhere (e.g. footer link). */
export function showCookiePreferences() {
  CC.showPreferences();
}
